import { CabinetUsersAPIService } from '@/services/backend/cabinet/users';
import { CabinetQuotationRequestsAPIService } from '@/services/backend/cabinet/quotation-requests';
import { ktru } from '@/services/backend/cabinet/ktru';

export const cabinet = {
    users: new CabinetUsersAPIService(),
    quotationRequests: new CabinetQuotationRequestsAPIService(),
    ktru: ktru
};
